var BOTH_VERSIONS_NULL = 'The minimum and maximum versions can not both be null';
var MIN_VERSION_TYPE = 'Minimum version must be an instance of the Version entity or null';
var MAX_VERSION_TYPE = 'Maximum version must be an instance of the Version entity or null';
var INVALID_RANGE = 'Invalid range, minimum version must be less than the maximum version';
var VERSION_TYPE = 'Version must be an instance of the Version entity';
var VERSION_RANGE_TYPE = 'VersionRange must be an instance of the Version Range entity';
export { BOTH_VERSIONS_NULL, INVALID_RANGE, MIN_VERSION_TYPE, MAX_VERSION_TYPE, VERSION_TYPE, VERSION_RANGE_TYPE };